import React from 'react';
import { HeartHandshake } from 'lucide-react';

const DesarrolloSocialAfectivo = ({ formData, setFormData, handleInputChange }) => {
    const handleHabitosChange = (campo, valor) => {
        setFormData(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const handleActividadesAgradables = (actividad, valor) => {
        setFormData(prev => ({
            ...prev,
            [`actividades_agradables_${actividad}`]: valor
        }));
    };

    const inputClasses = `w-full p-1.5 rounded-lg border border-gray-300 bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`;

    return (
        <div className="bg-white rounded-lg p-4 max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2 flex items-center">
                <HeartHandshake className="mr-2 text-blue-500 w-4 h-4" />
                Desarrollo Social y Afectivo
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                    <h4 className="text-sm font-medium text-gray-700 mb-2">5.1 Hábitos</h4>
                    <p className="text-xs text-gray-600 mb-4">
                        Para contestar los siguientes aspectos, tome en cuenta la siguiente categorización:<br/>
                        S=SIEMPRE, AV=ALGUNAS VECES, RV=RARA VEZ, N=NUNCA
                    </p>

                    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                        <table className="min-w-full">
                            <thead>
                                <tr className="bg-gray-50">
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-700 border-b">Aspectos</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">S</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">AV</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">RV</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">N</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    {id: 'juega_con_otros', label: 'Juega con hermanos u otros amigos'},
                                    {id: 'tiempo_celular_tv', label: 'Pasa mucho tiempo en el celular o TV'},
                                    {id: 'relacion_ninos', label: 'Se relaciona fácilmente con otros niños'},
                                    {id: 'relacion_adultos', label: 'Se relaciona fácilmente con otros adultos'},
                                    {id: 'afectuoso', label: 'Es afectuoso'},
                                    {id: 'independiente', label: 'Es independiente'},
                                    {id: 'sigue_instrucciones', label: 'Sigue instrucciones'},
                                    {id: 'organiza_objetos', label: 'Acostumbra a guardar sus objetos personales'}
                                ].map((item) => (
                                    <tr key={item.id} className="hover:bg-gray-50">
                                        <td className="px-4 py-2 text-sm text-gray-700 border-b">{item.label}</td>
                                        {['S', 'AV', 'RV', 'N'].map((valor) => (
                                            <td key={valor} className="px-4 py-2 text-center border-b">
                                                <input
                                                    type="radio"
                                                    name={item.id}
                                                    checked={formData[item.id] === valor}
                                                    onChange={() => handleHabitosChange(item.id, valor)}
                                                    className="form-radio text-indigo-600 h-4 w-4"
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="md:col-span-1">
                    <div className="bg-white p-4 rounded-lg border border-gray-200 h-full">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                            Pasatiempos favoritos
                        </label>
                        <textarea
                            name="pasatiempos"
                            value={formData.pasatiempos}
                            onChange={handleInputChange}
                            className={inputClasses}
                            rows="3"
                        />
                    </div>
                </div>

                <div className="md:col-span-1">
                    <div className="bg-white p-4 rounded-lg border border-gray-200 h-full">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                            ¿Presenta dificultad para relacionarse?
                        </label>
                        <div className="flex items-center space-x-4 mb-2">
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="dificultad_relaciones"
                                    checked={formData.dificultad_relaciones}
                                    onChange={() => handleHabitosChange('dificultad_relaciones', true)}
                                    className="form-radio text-indigo-600 h-4 w-4"
                                />
                                <span className="ml-2 text-sm">Sí</span>
                            </label>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="dificultad_relaciones"
                                    checked={!formData.dificultad_relaciones}
                                    onChange={() => handleHabitosChange('dificultad_relaciones', false)}
                                    className="form-radio text-indigo-600 h-4 w-4"
                                />
                                <span className="ml-2 text-sm">No</span>
                            </label>
                        </div>
                        {formData.dificultad_relaciones && (
                            <textarea
                                name="dificultad_relaciones_detalle"
                                placeholder="Especifique las dificultades"
                                value={formData.dificultad_relaciones_detalle}
                                onChange={handleInputChange}
                                className={inputClasses}
                                rows="3"
                            />
                        )}
                    </div>
                </div>

                <div className="md:col-span-1">
                    <div className="bg-white p-4 rounded-lg border border-gray-200 h-full">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                            Programas favoritos
                        </label>
                        <textarea
                            name="programas_favoritos"
                            value={formData.programas_favoritos}
                            onChange={handleInputChange}
                            className={inputClasses}
                            rows="3"
                        />
                    </div>
                </div>

                <div className="md:col-span-1">
                    <div className="bg-white p-4 rounded-lg border border-gray-200 h-full">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                            Personalidad del niño/a
                        </label>
                        <textarea
                            name="personalidad"
                            value={formData.personalidad}
                            onChange={handleInputChange}
                            className={inputClasses}
                            rows="3"
                        />
                    </div>
                </div>

                <div className="md:col-span-2">
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Actividades que le agradan
                    </label>
                    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                        <table className="min-w-full">
                            <thead>
                                <tr className="bg-gray-50">
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-700 border-b">Actividad</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">Si</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">No</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium text-gray-700 border-b">A veces</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    {id: 'dibujar', label: 'Dibujar'},
                                    {id: 'cantar', label: 'Cantar'},
                                    {id: 'escuchar_musica', label: 'Escuchar música'},
                                    {id: 'mirar_tv', label: 'Mirar TV'},
                                    {id: 'ir_al_cine', label: 'Ir al cine'},
                                    {id: 'escuchar_cuentos', label: 'Escuchar cuentos'},
                                    {id: 'realizar_deportes', label: 'Realizar deportes'},
                                    {id: 'video_infantiles', label: 'Videos infantiles'},
                                    {id: 'otros', label: 'Otros'}
                                ].map((actividad) => (
                                    <tr key={actividad.id} className="hover:bg-gray-50">
                                        <td className="px-4 py-2 text-sm text-gray-700 border-b">{actividad.label}</td>
                                        {['SI', 'NO', 'AV'].map((valor) => (
                                            <td key={valor} className="px-4 py-2 text-center border-b">
                                                <input
                                                    type="radio"
                                                    name={`actividades_agradables_${actividad.id}`}
                                                    checked={formData[`actividades_agradables_${actividad.id}`] === valor}
                                                    onChange={() => handleActividadesAgradables(actividad.id, valor)}
                                                    className="form-radio text-indigo-600 h-4 w-4"
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DesarrolloSocialAfectivo;
